/**
 * @file api-auth-reset.ts
 * @description Типизированные обёртки вокруг password-reset endpoints
 * `/auth/request-reset` и `/auth/reset/:token` (phase04 шаг 7).
 */

import { apiFetch } from "./api-client";

export async function requestPasswordReset(email: string): Promise<void> {
  await apiFetch<{ ok: true }>("/auth/request-reset", {
    method: "POST",
    json: { email },
  });
}

export async function confirmPasswordReset(token: string, password: string): Promise<void> {
  await apiFetch<{ ok: true }>(`/auth/reset/${encodeURIComponent(token)}`, {
    method: "POST",
    json: { password },
  });
}
